// extracted by mini-css-extract-plugin
export default {"card":"ProblemCard_card__t-sS2","image":"ProblemCard_image__Dsi0d","content":"ProblemCard_content__ziEXM","text":"ProblemCard_text__WchzT"};